/**
 * Designed to handle booting up the page and centralized task once the file loading is completed
 * 
 */

var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.BootFunctions = OCS.BootFunctions || {}; // Functions placed here will be ran at different points in the boot sequence
OCS.BootFunctions.dependencies = OCS.BootFunctions.dependencies || {};
OCS.Settings = OCS.Settings || {};
OCS.Settings.Viewer = OCS.Settings.Viewer || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};


OCS.WxBriefing.Functions.define_wx_briefing_boot = function () {
    if(OCS.Settings.Viewer.Config) {
        var config_ovrrides = OCS.Settings.Viewer.Config;
        if(Object.keys(config_ovrrides).length) {
            OCS.Viewer.Config = OCS.Utilities.combine_objects(OCS.Viewer.Config, config_ovrrides, {merge: true, deep: true, merge_mismatch: true});
        }
    }

    // Define the controller
    OCS.WxBriefing.Classes.WxBriefingController = new Class({
        Implements: [Options, Events],
        class_name: 'OCS.WxBriefing.Live.Controller',
        options: {
            debug: false,
        },
        states: {
            ui_ready: false,
        },
        timeout: null,
        bound_methods: {},
        initialize: function (ops) {
            if (OCS.WxBriefing.Live.Controller) {
                return OCS.WxBriefing.Live.Controller;
            }
            this.setOptions(ops);
            OCS.WxBriefing.Live.Controller = this;
            if (OCS.console) {
                OCS.console.log(this.class_name + ': Initializing the boot sequence.');
            }
            this.bound_methods.restart_ui = this.restart_ui.bind(this);
            this.bound_methods.on_xmpp_device_disconnect = this.on_xmpp_device_disconnect.bind(this);
            this.bound_methods.on_xmpp_device_kicked = this.on_xmpp_device_kicked.bind(this);
            // Apply the events if we are not debugging
            this.addEvent('ui_ready', this.on_ui_ready.bind(this));
            var em = OCS.WxBriefing.Functions.get_event_manager();
            em.subscribe({"event_name": "xmpp_device_disconnect", 'callback': this.bound_methods.on_xmpp_device_disconnect});
            em.subscribe({"event_name": "xmpp_device_kicked", 'callback': this.bound_methods.on_xmpp_device_kicked});
            em.subscribe({"event_name": "restart_application", 'callback': this.bound_methods.restart_ui});
        },

        // Actions
        start_ui: function () {
            if (OCS.WxBriefing.Classes && this.states.ui_ready && OCS.WxBriefing.Live.UI && !this.timeout) {
                this.timeout = setTimeout(OCS.WxBriefing.Live.UI.start.bind(OCS.WxBriefing.Live.UI), 0);
            } else {
                alert(this.class_name + ': Something went wrong. Please try reloading the page.');
            }
            return this;
        },
        stop_ui: function (callback) {
            this.timeout = null;
            OCS.WxBriefing.Live.UI.stop(callback);
        },
        restart_ui: function () {
            this.stop_ui(function () {
                OCS.console.debug_text(this.class_name + ': Application stopped.');
                // We want a complete reload since there might be code changes we need to grab
                var hash = '';
                if (window.location.hash) {
                    hash = window.location.hash;
                }
                var url = OCS.Settings.base_url;
                setTimeout(function() {
                    window.location.href = url + hash;
                    location.reload(true);
                }, 500);
                
            }.bind(this));
        },
        switch_platform: function (platform) {
            if (OCS.UI) {
                OCS.WxBriefing.Live.UI.stop(function () {
                    OCS.Bootstrap.platform_startup(platform);
                });
            } else {
                OCS.Bootstrap.platform_startup(platform);
            }
        },

        // Event Fires
        ui_ready: function () {
            // Taking over control from OCS.Bootstrap
            if (OCS.console) {
                if (this.options.debug) {
                    OCS.console.debug_text(this.class_name + ": Debug MODE ACTIVE! Please type OCS.WxBriefing.Live.Controller.on_ui_ready() into the console to start the UI.");
                }
            }
            this.fireEvent('ui_ready');
        },

        // Event Listeners
        on_ui_ready: function () {
            this.states.ui_ready = true;
            OCS.console.log(this.class_name + ': User Interface is now ready to start!');
            this.start_ui();
        },
        on_xmpp_device_disconnect: function () {

        },
        on_xmpp_device_kicked: function () {
            this.stop_ui(function () {
                alert(OCS.Constants.msgs.xmpp_device_kicked_off);
                window.location = '/index.php/okfirst';
            });
        },
        // Setters / Getters
        set_debug: function (cond) {
            this.options.debug = cond;
        },
        destroy: function () {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.removeEvents();
            delete OCS.WxBriefing.Live.Controller;
            var em = OCS.WxBriefing.Functions.get_event_manager();
            em.unsubscribe({"event_name": "restart_application", 'callback': this.bound_methods.restart_ui});
            em.unsubscribe({"event_name": "xmpp_device_kicked", 'callback': this.bound_methods.on_xmpp_device_kicked});
            em.unsubscribe({"event_name": "xmpp_device_disconnect", 'callback': this.bound_methods.on_xmpp_device_disconnect});
        }
    });

};
OCS.WxBriefing.Functions.init_wx_briefing_controller = function () {
    OCS.WxBriefing.Functions.define_wx_briefing_boot();
    new OCS.WxBriefing.Classes.WxBriefingController();
};

document.addEventListener('DOMContentLoaded', OCS.WxBriefing.Functions.get_wx_briefing_controller());